import { UserTransactionPaymentType } from 'src/type/position';
import { TransactionType, TransactionStatus } from 'src/type/transaction';

export const Options = [
  {
    value: 'all',
    label: 'ทุกประเภท',
  },
  {
    value: TransactionType.BUY_POSITION,
    label: 'ตัดซื้อ',
  },
  {
    value: TransactionType.SELL_POSITION,
    label: 'ตัดขาย',
  },
  {
    value: TransactionType.DEPOSIT,
    label: 'ฝากสินค้า',
  },
  {
    value: TransactionType.REDEEM,
    label: 'ถอนสินค้า',
  },
];

export const typeLabel = (type: TransactionType | string) =>
  Options.find((item) => item.value === type)?.label || '';

export const txAction = (type?: TransactionType) => {
  switch (type) {
    case TransactionType.BUY_POSITION:
      return 'ตัดซื้อ';
    case TransactionType.SELL_POSITION:
      return 'ตัดขาย';
    case TransactionType.DEPOSIT:
      return 'ฝากสินค้า';
    default:
      return '';
  }
};

export const statusAction = (status?: TransactionStatus) => {
  switch (status) {
    case TransactionStatus.SUCCESS:
      return 'อนุมัติ';
    case TransactionStatus.REJECTED:
    case TransactionStatus.CANCEL:
      return 'ปฎิเสธ';
    default:
      return '';
  }
};

export const paymentTypeLabel = (type?: UserTransactionPaymentType) => {
  switch (type) {
    case UserTransactionPaymentType.CASH:
      return 'เงินสด';
    case UserTransactionPaymentType.BANK:
      return 'โอนเงิน';
    case UserTransactionPaymentType.CREDIT:
      return 'เครดิต';
    default:
      return '';
  }
};

export const txStatusLabel = (status: TransactionStatus) => {
  switch (status) {
    case TransactionStatus.PENDING:
      return 'รอดำเนินการ';
    case TransactionStatus.SUCCESS:
      return 'สำเร็จ';
    case TransactionStatus.REJECTED:
      return 'ปฏิเสธ';
    case TransactionStatus.CANCEL:
      return 'ยกเลิก';
    case TransactionStatus.WAITING:
      return 'รอราคา';
    case TransactionStatus.FAILED:
      return 'ไม่สำเร็จ';
    default:
      return '';
  }
};
